import React, {useEffect} from 'react';
import css from './Step.module.scss';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import {usePulsoidClient} from '../../../PulsoidClient';
import {HeartRateInteractor} from '../../integrations/edit/integration/voicemod/HeartrateStatus';
import {WebMidiService} from '../WebMidiService';
import {ScrollService} from '../ScrollService';

type SETUP_HEART_RATE_MONITOR_STATUS =
  | 'disconnected'
  | 'never_connected'
  | 'connected';

export const HeartRateMonitorMidiStep: React.FC<{
  midi: WebMidiService;
  scroller: ScrollService;
}> = ({midi, scroller}) => {
  let client = usePulsoidClient();
  let [heartRate, setHeartRate] = React.useState<number | undefined>(undefined);

  let [status, setStatus] =
    React.useState<SETUP_HEART_RATE_MONITOR_STATUS>('disconnected');

  useEffect(() => {
    async function perform() {
      let stream = (await client.getStatistics()) as {count: number};
      setStatus(stream.count > 0 ? 'disconnected' : 'never_connected');
    }

    perform();
  }, [client]);

  useEffect(() => {
    if (midi.connected() && status === 'connected') {
      window.onbeforeunload = () => {
        return 'Leaving this page will stop heart rate transmission to the VRChat?';
      };
    }
    return () => {
      window.onbeforeunload = null;
    };
  }, [midi, status]);

  let badge = '';
  let badgeClass = css.badge_not_connected;
  let button = '';
  let action = () => Promise.resolve();

  switch (status) {
    case 'connected':
      badge = 'Connected';
      badgeClass = css.badge_connected;
      break;

    case 'disconnected':
      badge = 'Disconnected';
      button = 'How to connect?';
      action = async () => {
        scroller.scroll('mobile-application-setup');
      };
      break;

    case 'never_connected':
      badge = 'Disconnected';
      button = 'Get a compatible HRM';
      action = async () => {
        scroller.scroll('monitor-selection');
      };
      break;
  }

  return (
    <div className={css.step}>
      <HeartRateInteractor
        onWaitingData={() => {
          if (status === 'connected') {
            setStatus('disconnected');
          }
        }}
        onConnected={(heartRate) => {
          setStatus('connected');
          setHeartRate(heartRate);
          midi.sendHeartRate(heartRate);
        }}
      />
      <div>Heart Rate Monitor</div>
      <div className={badgeClass}>{badge}</div>
      <div className={css.action}>
        {heartRate && status == 'connected' ? (
          <div>Heart rate: {heartRate}</div>
        ) : (
          <ButtonV2 type="primary-outline" size="small" onLoaderClick={action}>
            {button}
          </ButtonV2>
        )}
      </div>
    </div>
  );
};
